module.exports = "<div class=\"team-container\">\r\n    <app-team *ngFor=\"let team of teams\" [team]=\"team\"></app-team>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/teams/team-list/team-list.component.html
// module id = ../../../../../src/app/teams/team-list/team-list.component.html
// module chunks = main